import React, { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'
import { completeRegistrationTrack } from '../utils/metaAd'

// TossPixel 타입 선언
declare global {
  interface Window {
    TossPixel: any
  }
}

interface AnalyticsProviderProps {
  userType?: string | null
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  userType,
}) => {
  useEffect(() => {
    const options = {
      autoConfig: true,
      debug: true,
    }

    const mainId = process.env.REACT_APP_META_AD_KEY

    // Meta Pixel 초기화
    ReactPixel.init(
      process.env.REACT_APP_META_AD_KEY
        ? process.env.REACT_APP_META_AD_KEY
        : '',
      undefined,
      options,
    )

    // Google Analytics 설정
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'AW-677452397')
    } else {
      console.error('gtag is not defined')
    }
  }, [])

  useEffect(() => {
    const userTypeBool = userType === 'true' ? true : false
    if (userTypeBool) {
      // Google Analytics 전환 이벤트
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-677452397/x4ZgCKzB3IwaEO20hMMC',
          value: 1.0,
          currency: 'KRW',
        })
      } else {
        console.error('gtag is not defined')
      }

      // Meta Pixel 회원가입 완료 이벤트
      completeRegistrationTrack()

      // TossPixel 회원가입 이벤트
      const tossPixelKey = process.env.REACT_APP_TOSS_PIXEL_KEY
      if (tossPixelKey && window.TossPixel) {
        try {
          new window.TossPixel(tossPixelKey).signUp()
        } catch (error) {
          console.error('TossPixel signUp failed:', error)
        }
      }
    }
  }, [userType])

  return null
}
